export function formatDate(date) {
  try {
    const day = String(date?.getDate())?.padStart(2, "0");
    const month = String(date?.getMonth() + 1)?.padStart(2, "0");
    const year = date?.getFullYear();
    return `${year}-${month}-${day}`;
  } catch (error) {
    return date;
  }
}

export function formatDateDDMMYYYY(date) {
  try {
    const day = String(date?.getDate())?.padStart(2, "0");
    const month = String(date?.getMonth() + 1)?.padStart(2, "0");
    const year = date?.getFullYear();
    return `${day}-${month}-${year}`;
  } catch (error) {
    return date;
  }
}

export function oneMonthFromTodayInputDate() {
  const d = new Date();
  d.setMonth(d.getMonth() + 1);
  return formatDate(d);
}

export function DateConverterForInputField(date) {
  try {
    const [day, month, year] = date.split("-");
    return `${year}-${month}-${day}`;
  } catch (error) {
    return date;
  }
}
export function formatDateWithSuffix(date) {
  try {
    // Handle string inputs by converting to Date object
    let dateObj;
    if (typeof date === "string") {
      // Handle various date formats (YYYY-MM-DD, DD-MM-YYYY, timestamps, etc.)
      dateObj = new Date(date);
    } else if (date instanceof Date) {
      dateObj = date;
    } else {
      return date; // Return as-is if not a valid date type
    }

    // Check if date is valid
    if (isNaN(dateObj.getTime())) {
      return date;
    }

    const day = dateObj.getDate();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[dateObj.getMonth()];
    const year = dateObj.getFullYear();

    const daySuffix = (day) => {
      if (day > 3 && day < 21) return "th"; // 11th, 12th, 13th, etc.
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${daySuffix(day)} ${month}, ${year}`;
  } catch (error) {
    return date; // Return original value if any error occurs
  }
}

export function getDays(date1, date2) {
  const diffTime = Math.abs(date2 - date1);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

export function getTime(date, options = { includeSeconds: false }) {
  const { includeSeconds } = options;
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0",
  )}${includeSeconds ? `:${String(seconds).padStart(2, "0")}` : ""}`;
}

export async function getCurrentDateTimeString() {
  const res = await fetch("http://worldtimeapi.org/api/ip");
  const data = await res.json();
  return data.datetime;
}

export function formatDateByPattern(date, pattern) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  let outputDate = pattern.replace("DD", day);
  outputDate = outputDate.replace("MM", month);
  outputDate = outputDate.replace("YYYY", year);
  outputDate = outputDate.replace("hh", hours);
  outputDate = outputDate.replace("mm", minutes);
  outputDate = outputDate.replace("ss", seconds);

  return outputDate;
}

export const getTimeDisplay = (
  time,
  mode = "countdown",
  expiredTimeText = "Expired",
  displayFormat = "dhms", // d=days, h=hours, m=minutes, s=seconds
) => {
  if (!time) return "Invalid Date"; // Handle missing values

  const targetTime = formatDateByPattern(time, "DD-MM-YYYY hh:mm:ss");
  // Parse DD-MM-YYYY HH:mm:ss format
  const parts = targetTime.split(" ");
  if (parts.length !== 2) return "Invalid Date";

  const [datePart, timePart] = parts;
  const [day, month, year] = datePart.split("-");
  const [hours = "00", minutes = "00", seconds = "00"] = timePart?.split(
    ":",
  ) || ["00", "00", "00"];

  // Validate parts exist
  if (!day || !month || !year || !hours || !minutes || !seconds) {
    return "Invalid Date";
  }

  // Create date object (month is 0-indexed in JavaScript Date)
  const targetDate = new Date(year, month - 1, day, hours, minutes, seconds);

  // Validate the date
  if (isNaN(targetDate.getTime())) return "Invalid Date";

  const now = new Date();
  const diffMs =
    mode === "countdown"
      ? targetDate.getTime() - now.getTime()
      : now.getTime() - targetDate.getTime();

  // For countdown mode, show expired text if time is up
  if (mode === "countdown" && diffMs <= 0) return expiredTimeText;

  // For countup mode, don't show negative values
  if (mode === "countup" && diffMs < 0) return "Not yet started";

  // Calculate time components
  const totalSeconds = Math.floor(Math.abs(diffMs) / 1000);
  const totalMinutes = Math.floor(totalSeconds / 60);
  const totalHours = Math.floor(totalMinutes / 60);
  const totalDays = Math.floor(totalHours / 24);

  const displayDays = totalDays;
  const displayHours = totalHours % 24;
  const displayMinutes = totalMinutes % 60;
  const displaySeconds = totalSeconds % 60;

  // Build display string based on format
  const parts_display = [];

  if (displayFormat.includes("d") && displayDays > 0) {
    parts_display.push(`${displayDays}d`);
  }

  if (displayFormat.includes("h")) {
    // Show hours even if 0 when days are shown, or when it's the first unit
    if (displayFormat.includes("d")) {
      parts_display.push(`${displayHours.toString().padStart(2, "0")}h`);
    } else {
      parts_display.push(`${totalHours}h`);
    }
  }

  if (displayFormat.includes("m")) {
    parts_display.push(`${displayMinutes.toString().padStart(2, "0")}m`);
  }

  if (displayFormat.includes("s")) {
    parts_display.push(`${displaySeconds.toString().padStart(2, "0")}s`);
  }

  return parts_display.join(" ");
};
